import { Button, Modal } from "react-bootstrap";

interface ShareableLinkInfoModalProps {
  isNsw?: boolean;
  seekProfileUrl: string;
  profileVisibilityUrl: string;
  show: boolean;
  onHide: () => void;
}

export const ShareableLinkInfoModal = ({
  isNsw = false,
  seekProfileUrl,
  profileVisibilityUrl,
  show,
  onHide,
}: ShareableLinkInfoModalProps) => {
  const subtitleClasses = isNsw ? "h4" : "h6";

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        {isNsw ? (
          <h1 className="modal-title h2">SEEK Profile link</h1>
        ) : (
          <Modal.Title>SEEK Profile link</Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body>
        <article>
          <h2 className={subtitleClasses}>What is a SEEK profile?</h2>
          <p>
            A{" "}
            <a href={seekProfileUrl} target="_blank" rel="noopener noreferrer">
              SEEK Profile
            </a>{" "}
            is an individual's professional summary, housed on SEEK. It lets
            candidates present a personal summary, career history, education and
            their skills to organisations and makes the application process
            easier.
          </p>
        </article>
        <article>
          <h2 className={subtitleClasses}>Why add your SEEK Profile?</h2>
          <p>
            When you add your SEEK Profile you are showing organisations the
            skills, experience and credentials they need to see, so you can
            start volunteering sooner.
          </p>
        </article>
        <article>
          <h2 className={subtitleClasses}>How do I add my SEEK Profile</h2>
          <p>
            You first must have a{" "}
            <a href={seekProfileUrl} target="_blank" rel="noopener noreferrer">
              SEEK Profile
            </a>
            . Your{" "}
            <a
              href={profileVisibilityUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Profile visibility
            </a>{" "}
            setting must be set to public to allow organisations to access it.
            You can then copy your Profile url from the top of your{" "}
            <b>SEEK Profile page</b> and include in the 'Profile link field' in
            the SEEK Volunteer application form.
          </p>
        </article>
        <article>
          <h2 className={subtitleClasses}>
            Can I still apply for a volunteer opportunity without a SEEK
            Profile?
          </h2>
          <p>
            Yes, adding a SEEK Profile link is completely optional. We know that
            not everyone has a SEEK Profile and it&apos;s not relevant for all
            volunteering opportunities.
          </p>
        </article>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Return to application
        </Button>
        <a
          href={seekProfileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
          css={`
            &.btn:focus {
              border-radius: 0.25rem;
            }
          `}
        >
          Get SEEK Profile link
        </a>
      </Modal.Footer>
    </Modal>
  );
};
